// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --scheduled-text-color: var(--black);
}

.scheduled-notifications {
  color: var(--scheduled-text-color);
  background: var(--orange-200);
  min-height: 48px;
  display: flex;
  justify-content: center;
}

.scheduled-notifications__notifications-list {
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 4px 10px 4px 20px;
}

.scheduled-notifications__message {
  font-size: 14px;
  font-weight: 300;
  line-height: 20px;
  width: fit-content;
}

.scheduled-notifications__message_bold {
  font-weight: 700;
}

.scheduled-notifications__close-btn {
  width: 40px;
  height: 40px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
  border: none;
}

.scheduled-notifications__close-btn:hover .scheduled-notifications__close-btn-icon > path {
  fill: var(--icon-primary-hover-color);
}

.scheduled-notifications__notification {
  display: flex;
  align-items: center;
}

.scheduled-notifications .scheduled-notifications__link {
  --link-color: var(--scheduled-text-color);
}
`, "",{"version":3,"sources":["webpack://./src/entities/App/ScheduledNotification/ScheduledNotification.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":[":root {\n  --scheduled-text-color: var(--black);\n}\n\n.scheduled-notifications {\n  color: var(--scheduled-text-color);\n  background: var(--orange-200);\n  min-height: 48px;\n  display: flex;\n  justify-content: center;\n}\n\n.scheduled-notifications__notifications-list {\n  width: 100%;\n  max-width: 1280px;\n  margin: auto;\n  padding: 4px 10px 4px 20px;\n}\n\n.scheduled-notifications__message {\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 20px;\n  width: fit-content;\n}\n\n.scheduled-notifications__message_bold {\n  font-weight: 700;\n}\n\n.scheduled-notifications__close-btn {\n  width: 40px;\n  height: 40px;\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n}\n\n.scheduled-notifications__close-btn:hover .scheduled-notifications__close-btn-icon > path {\n  fill: var(--icon-primary-hover-color);\n}\n\n.scheduled-notifications__notification {\n  display: flex;\n  align-items: center;\n}\n\n.scheduled-notifications .scheduled-notifications__link {\n  --link-color: var(--scheduled-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
